export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (collections, encodeURIComponent, slugUse) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (! collections) {
pug_html = pug_html + "\u003Cp\u003ELoading collections\u003C\u002Fp\u003E";
}
else {
pug_html = pug_html + "\u003Cul class=\"collections\"\u003E";
// iterate collections
;(function(){
  var $$obj = collections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var collection = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"collections\"\u003E\u003Ca" + (" class=\"name\""+pug_attr("href", `#/shop/collection/${encodeURIComponent(collection.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = collection.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cspan class=\"number-products\"\u003E\n" + (pug_escape(null == (pug_interp = (collection.product_names || []).length) ? "" : pug_interp)) + " products\u003C\u002Fspan\u003E\u003Cdiv class=\"slug-use\"\u003E\n";
if (! slugUse[collection.slug]) {
pug_html = pug_html + "";
}
else {
pug_html = pug_html + ("Pages: " + (pug_escape(null == (pug_interp = slugUse[collection.slug].join(", ")) ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var collection = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"collections\"\u003E\u003Ca" + (" class=\"name\""+pug_attr("href", `#/shop/collection/${encodeURIComponent(collection.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = collection.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cspan class=\"number-products\"\u003E\n" + (pug_escape(null == (pug_interp = (collection.product_names || []).length) ? "" : pug_interp)) + " products\u003C\u002Fspan\u003E\u003Cdiv class=\"slug-use\"\u003E\n";
if (! slugUse[collection.slug]) {
pug_html = pug_html + "";
}
else {
pug_html = pug_html + ("Pages: " + (pug_escape(null == (pug_interp = slugUse[collection.slug].join(", ")) ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cform class=\"new-collection\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003ECollection name\u003C\u002Flabel\u003E\u003Cinput class=\"form-control\" name=\"collection\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"add-collection\"\u003EAdd new collection\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "collections" in locals_for_with ?
        locals_for_with.collections :
        typeof collections !== 'undefined' ? collections : undefined, "encodeURIComponent" in locals_for_with ?
        locals_for_with.encodeURIComponent :
        typeof encodeURIComponent !== 'undefined' ? encodeURIComponent : undefined, "slugUse" in locals_for_with ?
        locals_for_with.slugUse :
        typeof slugUse !== 'undefined' ? slugUse : undefined));
    ;;return pug_html;}